(() => {
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

/*!
  * Bootstrap v5.3.0 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $d37552697cc5ea39$exports = {};

$parcel$export($d37552697cc5ea39$exports, "popperGenerator", () => $b3c2fd6800546b4b$export$ed5e13716264f202);
$parcel$export($d37552697cc5ea39$exports, "detectOverflow", () => $f765731200b57f98$export$2e2bcd8739ae039);
$parcel$export($d37552697cc5ea39$exports, "createPopperBase", () => $b3c2fd6800546b4b$export$8f7491d57c8f97a9);
$parcel$export($d37552697cc5ea39$exports, "createPopper", () => $1bf0bf541303046d$export$8f7491d57c8f97a9);
$parcel$export($d37552697cc5ea39$exports, "createPopperLite", () => $cff5cce2532d9fa1$export$8f7491d57c8f97a9);
var $f5c54167a3c62105$exports = {};

$parcel$export($f5c54167a3c62105$exports, "top", () => $f5c54167a3c62105$export$1e95b668f3b82d);
$parcel$export($f5c54167a3c62105$exports, "bottom", () => $f5c54167a3c62105$export$40e543e69a8b3fbb);
$parcel$export($f5c54167a3c62105$exports, "right", () => $f5c54167a3c62105$export$79ffe56a765070d2);
$parcel$export($f5c54167a3c62105$exports, "left", () => $f5c54167a3c62105$export$eabcd2c8791e7bf4);
$parcel$export($f5c54167a3c62105$exports, "auto", () => $f5c54167a3c62105$export$dfb5619354ba860);
$parcel$export($f5c54167a3c62105$exports, "basePlacements", () => $f5c54167a3c62105$export$aec2ce47c367b8c3);
$parcel$export($f5c54167a3c62105$exports, "start", () => $f5c54167a3c62105$export$b3571188c770cc5a);
$parcel$export($f5c54167a3c62105$exports, "end", () => $f5c54167a3c62105$export$bd5df0f255a350f8);
$parcel$export($f5c54167a3c62105$exports, "clippingParents", () => $f5c54167a3c62105$export$390fd549c5303b4d);
$parcel$export($f5c54167a3c62105$exports, "viewport", () => $f5c54167a3c62105$export$d7b7311ec04a3e8f);
$parcel$export($f5c54167a3c62105$exports, "popper", () => $f5c54167a3c62105$export$ae5ab1c730825774);
$parcel$export($f5c54167a3c62105$exports, "reference", () => $f5c54167a3c62105$export$ca50aac9f3ba507f);
$parcel$export($f5c54167a3c62105$exports, "variationPlacements", () => $f5c54167a3c62105$export$368f9a87e87fa4e1);
$parcel$export($f5c54167a3c62105$exports, "placements", () => $f5c54167a3c62105$export$803cd8101b6c182b);
$parcel$export($f5c54167a3c62105$exports, "beforeRead", () => $f5c54167a3c62105$export$421679a7c3d56e);
$parcel$export($f5c54167a3c62105$exports, "read", () => $f5c54167a3c62105$export$aafa59e2e03f2942);
$parcel$export($f5c54167a3c62105$exports, "afterRead", () => $f5c54167a3c62105$export$6964f6c886723980);
$parcel$export($f5c54167a3c62105$exports, "beforeMain", () => $f5c54167a3c62105$export$c65e99957a05207c);
$parcel$export($f5c54167a3c62105$exports, "main", () => $f5c54167a3c62105$export$f22da7240b7add18);
$parcel$export($f5c54167a3c62105$exports, "afterMain", () => $f5c54167a3c62105$export$bab79516f2d662fe);
$parcel$export($f5c54167a3c62105$exports, "beforeWrite", () => $f5c54167a3c62105$export$8d4d2d70e7d46032);
$parcel$export($f5c54167a3c62105$exports, "write", () => $f5c54167a3c62105$export$68d8715fc104d294);
$parcel$export($f5c54167a3c62105$exports, "afterWrite", () => $f5c54167a3c62105$export$70a6e5159acce2e6);
$parcel$export($f5c54167a3c62105$exports, "modifierPhases", () => $f5c54167a3c62105$export$d087d3878fdf71d5);
var $f5c54167a3c62105$export$1e95b668f3b82d = "top";
var $f5c54167a3c62105$export$40e543e69a8b3fbb = "bottom";
var $f5c54167a3c62105$export$79ffe56a765070d2 = "right";
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = "left";
var $f5c54167a3c62105$export$dfb5619354ba860 = "auto";
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = "start";
var $f5c54167a3c62105$export$bd5df0f255a350f8 = "end";
var $f5c54167a3c62105$export$390fd549c5303b4d = "clippingParents";
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = "viewport";
var $f5c54167a3c62105$export$ae5ab1c730825774 = "popper";
var $f5c54167a3c62105$export$ca50aac9f3ba507f = "reference";
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = "beforeRead";
var $f5c54167a3c62105$export$aafa59e2e03f2942 = "read";
var $f5c54167a3c62105$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = "beforeMain";
var $f5c54167a3c62105$export$f22da7240b7add18 = "main";
var $f5c54167a3c62105$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = "beforeWrite";
var $f5c54167a3c62105$export$68d8715fc104d294 = "write";
var $f5c54167a3c62105$export$70a6e5159acce2e6 = "afterWrite";
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];


var $1341d386dda6ba3e$exports = {};

$parcel$export($1341d386dda6ba3e$exports, "applyStyles", () => $83c1fc4c4e58d7dd$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "arrow", () => $1992f2d714808ab6$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "computeStyles", () => $c8f8eadcf7685dc5$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "eventListeners", () => $ff355aafd082b0cd$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "flip", () => $b1f32a1d9525a032$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "hide", () => $174d14927bb4f43b$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "offset", () => $7c04da2e958a3fe8$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "popperOffsets", () => $e92fb10df1450f31$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "preventOverflow", () => $3295dac8746ffe59$export$2e2bcd8739ae039);
function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        "computeStyles"
    ]
};



function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}



var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;



function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
}


function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $993d40d65cc118cd$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) >= 0;
}




function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    if (isIE && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element);
    if ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6829c22fb01dde5a$export$2e2bcd8739ae039)(offsetParent) && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}


function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $7e23bad950468b82$export$8960430cfd85939f)(min, (0, $7e23bad950468b82$export$96ec731ed4dcb222)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)(), paddingObject);
}


function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $d63950b756706495$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $c8f8eadcf7685dc5$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var sideY = (0, $f5c54167a3c62105$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(popper);
            if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || placement === (0, $f5c54167a3c62105$export$79ffe56a765070d2)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideY = (0, $f5c54167a3c62105$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || placement === (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideX = (0, $f5c54167a3c62105$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};



var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};


var $825ae98fe4f5d029$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}



var $76c023b5f4bd6339$var$hash = {
    start: "end",
    end: "start"
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}








function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $84019ab652aa921b$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)).left + (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $993d40d65cc118cd$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $7e23bad950468b82$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node) && (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(node));
}





function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3eb5703c925e0e5d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(target)));
}










function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) ? (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $7b0a0ce1fa68929f$export$2e2bcd8739ae039)(element, strategy)) : (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $3e70615fb3e74824$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $a621d360f1a81b88$export$2e2bcd8739ae039)((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) ? (0, $a56b734280245ffb$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $d63950b756706495$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $f5c54167a3c62105$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $f5c54167a3c62105$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $f5c54167a3c62105$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $f5c54167a3c62105$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $f5c54167a3c62105$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $f5c54167a3c62105$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $f5c54167a3c62105$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $f5c54167a3c62105$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? (0, $f5c54167a3c62105$export$ca50aac9f3ba507f) : (0, $f5c54167a3c62105$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $631049efb60e96c6$export$2e2bcd8739ae039)((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $f5c54167a3c62105$export$79ffe56a765070d2),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $f5c54167a3c62105$export$1e95b668f3b82d),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $f5c54167a3c62105$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $f5c54167a3c62105$export$368f9a87e87fa4e1) : (0, $f5c54167a3c62105$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $f5c54167a3c62105$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $afe288682115fde3$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(placement);
    return [
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860) ? (0, $dbd70d4ba9902caa$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$b3571188c770cc5a);
        var isVertical = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $f5c54167a3c62105$export$79ffe56a765070d2) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $f5c54167a3c62105$export$1e95b668f3b82d),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2),
        (0, $f5c54167a3c62105$export$40e543e69a8b3fbb),
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $174d14927bb4f43b$var$hide
};




function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $f5c54167a3c62105$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $7c04da2e958a3fe8$var$offset
};



function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};





function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $d8b68132b61080af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $a56b734280245ffb$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? (0, $7e23bad950468b82$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $7e23bad950468b82$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b6f0b0266e764faa$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};








function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node) || !(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node)) return (0, $68a584be1dc90596$export$2e2bcd8739ae039)(node);
    else return (0, $9102221f9e13ae54$export$2e2bcd8739ae039)(node);
}








function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ca14c6927ef497ac$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $f5c54167a3c62105$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(reference) ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $0baf5472b5ad4a5a$export$2e2bcd8739ae039)((0, $46d929ffbbd3136a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $34abf65a06d63352$export$2e2bcd8739ae039)(reference, (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b65b878009bf47f$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039),
    (0, $7c04da2e958a3fe8$export$2e2bcd8739ae039),
    (0, $b1f32a1d9525a032$export$2e2bcd8739ae039),
    (0, $3295dac8746ffe59$export$2e2bcd8739ae039),
    (0, $1992f2d714808ab6$export$2e2bcd8739ae039),
    (0, $174d14927bb4f43b$export$2e2bcd8739ae039)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $cff5cce2532d9fa1$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039)
];
var $cff5cce2532d9fa1$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $cff5cce2532d9fa1$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($d37552697cc5ea39$exports, $f5c54167a3c62105$exports);
$parcel$exportWildcard($d37552697cc5ea39$exports, $1341d386dda6ba3e$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$elementMap = new Map();
const $91ca15859685b28b$var$Data = {
    set (element, key, instance) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) $91ca15859685b28b$var$elementMap.set(element, new Map());
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($91ca15859685b28b$var$elementMap.has(element)) return $91ca15859685b28b$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) return;
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $91ca15859685b28b$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$MAX_UID = 1000000;
const $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER = 1000;
const $91ca15859685b28b$var$TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $91ca15859685b28b$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $91ca15859685b28b$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $91ca15859685b28b$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $91ca15859685b28b$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $91ca15859685b28b$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER;
};
const $91ca15859685b28b$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($91ca15859685b28b$var$TRANSITION_END));
};
const $91ca15859685b28b$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $91ca15859685b28b$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($91ca15859685b28b$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($91ca15859685b28b$var$parseSelector(object));
    return null;
};
const $91ca15859685b28b$var$isVisible = (element)=>{
    if (!$91ca15859685b28b$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $91ca15859685b28b$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $91ca15859685b28b$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $91ca15859685b28b$var$findShadowRoot(element.parentNode);
};
const $91ca15859685b28b$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $91ca15859685b28b$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $91ca15859685b28b$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $91ca15859685b28b$var$DOMContentLoadedCallbacks = [];
const $91ca15859685b28b$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$91ca15859685b28b$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $91ca15859685b28b$var$DOMContentLoadedCallbacks)callback();
        });
        $91ca15859685b28b$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $91ca15859685b28b$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $91ca15859685b28b$var$defineJQueryPlugin = (plugin)=>{
    $91ca15859685b28b$var$onDOMContentLoaded(()=>{
        const $ = $91ca15859685b28b$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $91ca15859685b28b$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const $91ca15859685b28b$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $91ca15859685b28b$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $91ca15859685b28b$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
        $91ca15859685b28b$var$execute(callback);
    };
    transitionElement.addEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $91ca15859685b28b$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $91ca15859685b28b$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $91ca15859685b28b$var$stripNameRegex = /\..*/;
const $91ca15859685b28b$var$stripUidRegex = /::\d+$/;
const $91ca15859685b28b$var$eventRegistry = {}; // Events storage
let $91ca15859685b28b$var$uidEvent = 1;
const $91ca15859685b28b$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $91ca15859685b28b$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $91ca15859685b28b$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$91ca15859685b28b$var$uidEvent++}` || element.uidEvent || $91ca15859685b28b$var$uidEvent++;
}
function $91ca15859685b28b$var$getElementEvents(element) {
    const uid = $91ca15859685b28b$var$makeEventUid(element);
    element.uidEvent = uid;
    $91ca15859685b28b$var$eventRegistry[uid] = $91ca15859685b28b$var$eventRegistry[uid] || {};
    return $91ca15859685b28b$var$eventRegistry[uid];
}
function $91ca15859685b28b$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $91ca15859685b28b$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $91ca15859685b28b$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $91ca15859685b28b$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $91ca15859685b28b$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $91ca15859685b28b$var$getTypeEvent(originalTypeEvent);
    if (!$91ca15859685b28b$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $91ca15859685b28b$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $91ca15859685b28b$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $91ca15859685b28b$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $91ca15859685b28b$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $91ca15859685b28b$var$makeEventUid(callable, originalTypeEvent.replace($91ca15859685b28b$var$namespaceRegex, ""));
    const fn = isDelegated ? $91ca15859685b28b$var$bootstrapDelegationHandler(element, handler, callable) : $91ca15859685b28b$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $91ca15859685b28b$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $91ca15859685b28b$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $91ca15859685b28b$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $91ca15859685b28b$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($91ca15859685b28b$var$stripNameRegex, "");
    return $91ca15859685b28b$var$customEvents[event] || event;
}
const $91ca15859685b28b$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $91ca15859685b28b$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $91ca15859685b28b$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$91ca15859685b28b$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($91ca15859685b28b$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $91ca15859685b28b$var$getjQuery();
        const typeEvent = $91ca15859685b28b$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $91ca15859685b28b$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $91ca15859685b28b$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $91ca15859685b28b$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $91ca15859685b28b$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $91ca15859685b28b$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $91ca15859685b28b$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $91ca15859685b28b$var$normalizeData(element.getAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $91ca15859685b28b$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $91ca15859685b28b$var$isElement(value) ? "element" : $91ca15859685b28b$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$VERSION = "5.3.0";
/**
 * Class definition
 */ class $91ca15859685b28b$var$BaseComponent extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        element = $91ca15859685b28b$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $91ca15859685b28b$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $91ca15859685b28b$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $91ca15859685b28b$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $91ca15859685b28b$var$Data.get($91ca15859685b28b$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $91ca15859685b28b$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return $91ca15859685b28b$var$parseSelector(selector);
};
const $91ca15859685b28b$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$91ca15859685b28b$var$isDisabled(el) && $91ca15859685b28b$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        if (selector) return $91ca15859685b28b$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $91ca15859685b28b$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($91ca15859685b28b$var$isDisabled(this)) return;
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$f = "alert";
const $91ca15859685b28b$var$DATA_KEY$a = "bs.alert";
const $91ca15859685b28b$var$EVENT_KEY$b = `.${$91ca15859685b28b$var$DATA_KEY$a}`;
const $91ca15859685b28b$var$EVENT_CLOSE = `close${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$EVENT_CLOSED = `closed${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE$5 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $91ca15859685b28b$export$caec2af78bcc877f extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$e = "button";
const $91ca15859685b28b$var$DATA_KEY$9 = "bs.button";
const $91ca15859685b28b$var$EVENT_KEY$a = `.${$91ca15859685b28b$var$DATA_KEY$9}`;
const $91ca15859685b28b$var$DATA_API_KEY$6 = ".data-api";
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$3 = "active";
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6 = `click${$91ca15859685b28b$var$EVENT_KEY$a}${$91ca15859685b28b$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$353f5b6fc5456de1 extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5);
    const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$d = "swipe";
const $91ca15859685b28b$var$EVENT_KEY$9 = ".bs.swipe";
const $91ca15859685b28b$var$EVENT_TOUCHSTART = `touchstart${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHMOVE = `touchmove${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHEND = `touchend${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERDOWN = `pointerdown${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERUP = `pointerup${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$POINTER_TYPE_TOUCH = "touch";
const $91ca15859685b28b$var$POINTER_TYPE_PEN = "pen";
const $91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $91ca15859685b28b$var$SWIPE_THRESHOLD = 40;
const $91ca15859685b28b$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $91ca15859685b28b$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Swipe extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$91ca15859685b28b$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$c;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$c;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$d;
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $91ca15859685b28b$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $91ca15859685b28b$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $91ca15859685b28b$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_PEN || event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$c = "carousel";
const $91ca15859685b28b$var$DATA_KEY$8 = "bs.carousel";
const $91ca15859685b28b$var$EVENT_KEY$8 = `.${$91ca15859685b28b$var$DATA_KEY$8}`;
const $91ca15859685b28b$var$DATA_API_KEY$5 = ".data-api";
const $91ca15859685b28b$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $91ca15859685b28b$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $91ca15859685b28b$var$ORDER_NEXT = "next";
const $91ca15859685b28b$var$ORDER_PREV = "prev";
const $91ca15859685b28b$var$DIRECTION_LEFT = "left";
const $91ca15859685b28b$var$DIRECTION_RIGHT = "right";
const $91ca15859685b28b$var$EVENT_SLIDE = `slide${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_SLID = `slid${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN$1 = `keydown${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSEENTER$1 = `mouseenter${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSELEAVE$1 = `mouseleave${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_DRAG_START = `dragstart${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3 = `load${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5 = `click${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$CLASS_NAME_CAROUSEL = "carousel";
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$2 = "active";
const $91ca15859685b28b$var$CLASS_NAME_SLIDE = "slide";
const $91ca15859685b28b$var$CLASS_NAME_END = "carousel-item-end";
const $91ca15859685b28b$var$CLASS_NAME_START = "carousel-item-start";
const $91ca15859685b28b$var$CLASS_NAME_NEXT = "carousel-item-next";
const $91ca15859685b28b$var$CLASS_NAME_PREV = "carousel-item-prev";
const $91ca15859685b28b$var$SELECTOR_ACTIVE = ".active";
const $91ca15859685b28b$var$SELECTOR_ITEM = ".carousel-item";
const $91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM = $91ca15859685b28b$var$SELECTOR_ACTIVE + $91ca15859685b28b$var$SELECTOR_ITEM;
const $91ca15859685b28b$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $91ca15859685b28b$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $91ca15859685b28b$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $91ca15859685b28b$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $91ca15859685b28b$var$KEY_TO_DIRECTION = {
    [$91ca15859685b28b$var$ARROW_LEFT_KEY$1]: $91ca15859685b28b$var$DIRECTION_RIGHT,
    [$91ca15859685b28b$var$ARROW_RIGHT_KEY$1]: $91ca15859685b28b$var$DIRECTION_LEFT
};
const $91ca15859685b28b$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $91ca15859685b28b$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$144901db2ea8e967 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $91ca15859685b28b$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$b;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$b;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$c;
    }
    // Public
    next() {
        this._slide($91ca15859685b28b$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $91ca15859685b28b$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($91ca15859685b28b$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $91ca15859685b28b$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $91ca15859685b28b$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM_IMG, this._element))$91ca15859685b28b$var$EventHandler.on(img, $91ca15859685b28b$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $91ca15859685b28b$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $91ca15859685b28b$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $91ca15859685b28b$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $91ca15859685b28b$var$ORDER_NEXT;
        const nextElement = element || $91ca15859685b28b$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $91ca15859685b28b$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($91ca15859685b28b$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_START : $91ca15859685b28b$var$CLASS_NAME_END;
        const orderClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_NEXT : $91ca15859685b28b$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $91ca15859685b28b$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($91ca15859685b28b$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($91ca15859685b28b$var$isRTL()) return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_PREV : $91ca15859685b28b$var$ORDER_NEXT;
        return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($91ca15859685b28b$var$isRTL()) return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_LEFT : $91ca15859685b28b$var$DIRECTION_RIGHT;
        return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_RIGHT : $91ca15859685b28b$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5, $91ca15859685b28b$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($91ca15859685b28b$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($91ca15859685b28b$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$b = "collapse";
const $91ca15859685b28b$var$DATA_KEY$7 = "bs.collapse";
const $91ca15859685b28b$var$EVENT_KEY$7 = `.${$91ca15859685b28b$var$DATA_KEY$7}`;
const $91ca15859685b28b$var$DATA_API_KEY$4 = ".data-api";
const $91ca15859685b28b$var$EVENT_SHOW$6 = `show${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_SHOWN$6 = `shown${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDE$6 = `hide${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$6 = `hidden${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4 = `click${$91ca15859685b28b$var$EVENT_KEY$7}${$91ca15859685b28b$var$DATA_API_KEY$4}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$7 = "show";
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSE = "collapse";
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSING = "collapsing";
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSED = "collapsed";
const $91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE} .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE}`;
const $91ca15859685b28b$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $91ca15859685b28b$var$WIDTH = "width";
const $91ca15859685b28b$var$HEIGHT = "height";
const $91ca15859685b28b$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $91ca15859685b28b$var$Default$a = {
    parent: null,
    toggle: true
};
const $91ca15859685b28b$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$78768a9af065a7b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $91ca15859685b28b$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $91ca15859685b28b$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$a;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$a;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $91ca15859685b28b$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_HORIZONTAL) ? $91ca15859685b28b$var$WIDTH : $91ca15859685b28b$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $91ca15859685b28b$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of $91ca15859685b28b$var$SelectorEngine.getMultipleElementsFromSelector(this))$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$a = "dropdown";
const $91ca15859685b28b$var$DATA_KEY$6 = "bs.dropdown";
const $91ca15859685b28b$var$EVENT_KEY$6 = `.${$91ca15859685b28b$var$DATA_KEY$6}`;
const $91ca15859685b28b$var$DATA_API_KEY$3 = ".data-api";
const $91ca15859685b28b$var$ESCAPE_KEY$2 = "Escape";
const $91ca15859685b28b$var$TAB_KEY$1 = "Tab";
const $91ca15859685b28b$var$ARROW_UP_KEY$1 = "ArrowUp";
const $91ca15859685b28b$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $91ca15859685b28b$var$EVENT_HIDE$5 = `hide${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$5 = `hidden${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOW$5 = `show${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOWN$5 = `shown${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3 = `click${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API = `keydown${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYUP_DATA_API = `keyup${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$6 = "show";
const $91ca15859685b28b$var$CLASS_NAME_DROPUP = "dropup";
const $91ca15859685b28b$var$CLASS_NAME_DROPEND = "dropend";
const $91ca15859685b28b$var$CLASS_NAME_DROPSTART = "dropstart";
const $91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3}.${$91ca15859685b28b$var$CLASS_NAME_SHOW$6}`;
const $91ca15859685b28b$var$SELECTOR_MENU = ".dropdown-menu";
const $91ca15859685b28b$var$SELECTOR_NAVBAR = ".navbar";
const $91ca15859685b28b$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $91ca15859685b28b$var$PLACEMENT_TOP = $91ca15859685b28b$var$isRTL() ? "top-end" : "top-start";
const $91ca15859685b28b$var$PLACEMENT_TOPEND = $91ca15859685b28b$var$isRTL() ? "top-start" : "top-end";
const $91ca15859685b28b$var$PLACEMENT_BOTTOM = $91ca15859685b28b$var$isRTL() ? "bottom-end" : "bottom-start";
const $91ca15859685b28b$var$PLACEMENT_BOTTOMEND = $91ca15859685b28b$var$isRTL() ? "bottom-start" : "bottom-end";
const $91ca15859685b28b$var$PLACEMENT_RIGHT = $91ca15859685b28b$var$isRTL() ? "left-start" : "right-start";
const $91ca15859685b28b$var$PLACEMENT_LEFT = $91ca15859685b28b$var$isRTL() ? "right-start" : "left-start";
const $91ca15859685b28b$var$PLACEMENT_TOPCENTER = "top";
const $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $91ca15859685b28b$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $91ca15859685b28b$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$931cbfb6bfb85fc extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $91ca15859685b28b$var$SelectorEngine.next(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.prev(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$9;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$9;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($91ca15859685b28b$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, "mouseover", $91ca15859685b28b$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, "mouseover", $91ca15859685b28b$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $91ca15859685b28b$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$91ca15859685b28b$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$91ca15859685b28b$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $d37552697cc5ea39$exports === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($91ca15859685b28b$var$isElement(this._config.reference)) referenceElement = $91ca15859685b28b$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $d37552697cc5ea39$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPEND)) return $91ca15859685b28b$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPSTART)) return $91ca15859685b28b$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER)) return $91ca15859685b28b$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER)) return $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP)) return isEnd ? $91ca15859685b28b$var$PLACEMENT_TOPEND : $91ca15859685b28b$var$PLACEMENT_TOP;
        return isEnd ? $91ca15859685b28b$var$PLACEMENT_BOTTOMEND : $91ca15859685b28b$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($91ca15859685b28b$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $91ca15859685b28b$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$91ca15859685b28b$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $91ca15859685b28b$var$getNextActiveElement(items, target, key === $91ca15859685b28b$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $91ca15859685b28b$var$TAB_KEY$1) return;
        const openToggles = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $91ca15859685b28b$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $91ca15859685b28b$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $91ca15859685b28b$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $91ca15859685b28b$var$ARROW_UP_KEY$1,
            $91ca15859685b28b$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3) ? this : $91ca15859685b28b$var$SelectorEngine.prev(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.next(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_MENU, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYUP_DATA_API, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$9 = "backdrop";
const $91ca15859685b28b$var$CLASS_NAME_FADE$4 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$5 = "show";
const $91ca15859685b28b$var$EVENT_MOUSEDOWN = `mousedown.bs.${$91ca15859685b28b$var$NAME$9}`;
const $91ca15859685b28b$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $91ca15859685b28b$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Backdrop extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$8;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$8;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $91ca15859685b28b$var$reflow(element);
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $91ca15859685b28b$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $91ca15859685b28b$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $91ca15859685b28b$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $91ca15859685b28b$var$EventHandler.on(element, $91ca15859685b28b$var$EVENT_MOUSEDOWN, ()=>{
            $91ca15859685b28b$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $91ca15859685b28b$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$8 = "focustrap";
const $91ca15859685b28b$var$DATA_KEY$5 = "bs.focustrap";
const $91ca15859685b28b$var$EVENT_KEY$5 = `.${$91ca15859685b28b$var$DATA_KEY$5}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN$2 = `focusin${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_TAB = `keydown.tab${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$TAB_KEY = "Tab";
const $91ca15859685b28b$var$TAB_NAV_FORWARD = "forward";
const $91ca15859685b28b$var$TAB_NAV_BACKWARD = "backward";
const $91ca15859685b28b$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $91ca15859685b28b$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$FocusTrap extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$7;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$7;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5); // guard against infinite focus loop
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $91ca15859685b28b$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $91ca15859685b28b$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $91ca15859685b28b$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $91ca15859685b28b$var$TAB_NAV_BACKWARD : $91ca15859685b28b$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $91ca15859685b28b$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $91ca15859685b28b$var$PROPERTY_PADDING = "padding-right";
const $91ca15859685b28b$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $91ca15859685b28b$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $91ca15859685b28b$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $91ca15859685b28b$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $91ca15859685b28b$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($91ca15859685b28b$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $91ca15859685b28b$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$7 = "modal";
const $91ca15859685b28b$var$DATA_KEY$4 = "bs.modal";
const $91ca15859685b28b$var$EVENT_KEY$4 = `.${$91ca15859685b28b$var$DATA_KEY$4}`;
const $91ca15859685b28b$var$DATA_API_KEY$2 = ".data-api";
const $91ca15859685b28b$var$ESCAPE_KEY$1 = "Escape";
const $91ca15859685b28b$var$EVENT_HIDE$4 = `hide${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$4 = `hidden${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOW$4 = `show${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOWN$4 = `shown${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_RESIZE$1 = `resize${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DISMISS = `click.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2 = `click${$91ca15859685b28b$var$EVENT_KEY$4}${$91ca15859685b28b$var$DATA_API_KEY$2}`;
const $91ca15859685b28b$var$CLASS_NAME_OPEN = "modal-open";
const $91ca15859685b28b$var$CLASS_NAME_FADE$3 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$4 = "show";
const $91ca15859685b28b$var$CLASS_NAME_STATIC = "modal-static";
const $91ca15859685b28b$var$OPEN_SELECTOR$1 = ".modal.show";
const $91ca15859685b28b$var$SELECTOR_DIALOG = ".modal-dialog";
const $91ca15859685b28b$var$SELECTOR_MODAL_BODY = ".modal-body";
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $91ca15859685b28b$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $91ca15859685b28b$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$2b77a92f1a5ad772 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $91ca15859685b28b$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$6;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$6;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($91ca15859685b28b$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(window, $91ca15859685b28b$var$EVENT_KEY$4);
        $91ca15859685b28b$var$EventHandler.off(this._dialog, $91ca15859685b28b$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $91ca15859685b28b$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($91ca15859685b28b$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$4, ()=>{
            if ($91ca15859685b28b$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $91ca15859685b28b$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$6 = "offcanvas";
const $91ca15859685b28b$var$DATA_KEY$3 = "bs.offcanvas";
const $91ca15859685b28b$var$EVENT_KEY$3 = `.${$91ca15859685b28b$var$DATA_KEY$3}`;
const $91ca15859685b28b$var$DATA_API_KEY$1 = ".data-api";
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2 = `load${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$ESCAPE_KEY = "Escape";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$3 = "show";
const $91ca15859685b28b$var$CLASS_NAME_SHOWING$1 = "showing";
const $91ca15859685b28b$var$CLASS_NAME_HIDING = "hiding";
const $91ca15859685b28b$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $91ca15859685b28b$var$OPEN_SELECTOR = ".offcanvas.show";
const $91ca15859685b28b$var$EVENT_SHOW$3 = `show${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_SHOWN$3 = `shown${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE$3 = `hide${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$3 = `hidden${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_RESIZE = `resize${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1 = `click${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $91ca15859685b28b$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $91ca15859685b28b$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$591ca0244c9dfcd4 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$5;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$5;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$3, $91ca15859685b28b$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $91ca15859685b28b$var$Backdrop({
            className: $91ca15859685b28b$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($91ca15859685b28b$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $91ca15859685b28b$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$OPEN_SELECTOR))$91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $91ca15859685b28b$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $91ca15859685b28b$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $91ca15859685b28b$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $91ca15859685b28b$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($91ca15859685b28b$var$uriAttributes.has(attributeName)) return Boolean($91ca15859685b28b$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $91ca15859685b28b$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$91ca15859685b28b$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$5 = "TemplateFactory";
const $91ca15859685b28b$var$Default$4 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $91ca15859685b28b$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $91ca15859685b28b$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$TemplateFactory extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$4;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$4;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $91ca15859685b28b$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $91ca15859685b28b$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($91ca15859685b28b$var$isElement(content)) {
            this._putElementInTemplate($91ca15859685b28b$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $91ca15859685b28b$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$4 = "tooltip";
const $91ca15859685b28b$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $91ca15859685b28b$var$CLASS_NAME_FADE$2 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_MODAL = "modal";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$2 = "show";
const $91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $91ca15859685b28b$var$SELECTOR_MODAL = `.${$91ca15859685b28b$var$CLASS_NAME_MODAL}`;
const $91ca15859685b28b$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $91ca15859685b28b$var$TRIGGER_HOVER = "hover";
const $91ca15859685b28b$var$TRIGGER_FOCUS = "focus";
const $91ca15859685b28b$var$TRIGGER_CLICK = "click";
const $91ca15859685b28b$var$TRIGGER_MANUAL = "manual";
const $91ca15859685b28b$var$EVENT_HIDE$2 = "hide";
const $91ca15859685b28b$var$EVENT_HIDDEN$2 = "hidden";
const $91ca15859685b28b$var$EVENT_SHOW$2 = "show";
const $91ca15859685b28b$var$EVENT_SHOWN$2 = "shown";
const $91ca15859685b28b$var$EVENT_INSERTED = "inserted";
const $91ca15859685b28b$var$EVENT_CLICK$1 = "click";
const $91ca15859685b28b$var$EVENT_FOCUSIN$1 = "focusin";
const $91ca15859685b28b$var$EVENT_FOCUSOUT$1 = "focusout";
const $91ca15859685b28b$var$EVENT_MOUSEENTER = "mouseenter";
const $91ca15859685b28b$var$EVENT_MOUSELEAVE = "mouseleave";
const $91ca15859685b28b$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $91ca15859685b28b$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $91ca15859685b28b$var$isRTL() ? "right" : "left"
};
const $91ca15859685b28b$var$Default$3 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $91ca15859685b28b$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$28c660c63b792dea extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        if (typeof $d37552697cc5ea39$exports === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$3;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$3;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $91ca15859685b28b$var$EventHandler.off(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOW$2));
        const shadowRoot = $91ca15859685b28b$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, "mouseover", $91ca15859685b28b$var$noop);
        const complete = ()=>{
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, "mouseover", $91ca15859685b28b$var$noop);
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_FADE$2, $91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $91ca15859685b28b$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $91ca15859685b28b$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $91ca15859685b28b$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $91ca15859685b28b$var$AttachmentMap[placement.toUpperCase()];
        return $d37552697cc5ea39$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $91ca15859685b28b$var$EventHandler.on(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $91ca15859685b28b$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSEENTER) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSELEAVE) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSOUT$1);
                $91ca15859685b28b$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $91ca15859685b28b$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $91ca15859685b28b$var$EventHandler.on(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $91ca15859685b28b$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($91ca15859685b28b$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $91ca15859685b28b$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$3 = "popover";
const $91ca15859685b28b$var$SELECTOR_TITLE = ".popover-header";
const $91ca15859685b28b$var$SELECTOR_CONTENT = ".popover-body";
const $91ca15859685b28b$var$Default$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $91ca15859685b28b$var$DefaultType$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$5b6b19405a83ff9d extends $91ca15859685b28b$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$2;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$2;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TITLE]: this._getTitle(),
            [$91ca15859685b28b$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$2 = "scrollspy";
const $91ca15859685b28b$var$DATA_KEY$2 = "bs.scrollspy";
const $91ca15859685b28b$var$EVENT_KEY$2 = `.${$91ca15859685b28b$var$DATA_KEY$2}`;
const $91ca15859685b28b$var$DATA_API_KEY = ".data-api";
const $91ca15859685b28b$var$EVENT_ACTIVATE = `activate${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_CLICK = `click${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1 = `load${$91ca15859685b28b$var$EVENT_KEY$2}${$91ca15859685b28b$var$DATA_API_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$1 = "active";
const $91ca15859685b28b$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $91ca15859685b28b$var$SELECTOR_TARGET_LINKS = "[href]";
const $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $91ca15859685b28b$var$SELECTOR_NAV_LINKS = ".nav-link";
const $91ca15859685b28b$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $91ca15859685b28b$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $91ca15859685b28b$var$SELECTOR_LINK_ITEMS = `${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_NAV_ITEMS} > ${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_LIST_ITEMS}`;
const $91ca15859685b28b$var$SELECTOR_DROPDOWN = ".dropdown";
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $91ca15859685b28b$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $91ca15859685b28b$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$a6472a5298a374be extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$1;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$1;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $91ca15859685b28b$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $91ca15859685b28b$var$EventHandler.off(this._config.target, $91ca15859685b28b$var$EVENT_CLICK);
        $91ca15859685b28b$var$EventHandler.on(this._config.target, $91ca15859685b28b$var$EVENT_CLICK, $91ca15859685b28b$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $91ca15859685b28b$var$isDisabled(anchor)) continue;
            const observableSection = $91ca15859685b28b$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($91ca15859685b28b$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($91ca15859685b28b$var$SELECTOR_DROPDOWN)).classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $91ca15859685b28b$var$SelectorEngine.parents(target, $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $91ca15859685b28b$var$SelectorEngine.prev(listGroup, $91ca15859685b28b$var$SELECTOR_LINK_ITEMS))item.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $91ca15859685b28b$var$SelectorEngine.find(`${$91ca15859685b28b$var$SELECTOR_TARGET_LINKS}.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_SPY))$91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$1 = "tab";
const $91ca15859685b28b$var$DATA_KEY$1 = "bs.tab";
const $91ca15859685b28b$var$EVENT_KEY$1 = `.${$91ca15859685b28b$var$DATA_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDE$1 = `hide${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$1 = `hidden${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOW$1 = `show${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOWN$1 = `shown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API = `click${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN = `keydown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API = `load${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$ARROW_LEFT_KEY = "ArrowLeft";
const $91ca15859685b28b$var$ARROW_RIGHT_KEY = "ArrowRight";
const $91ca15859685b28b$var$ARROW_UP_KEY = "ArrowUp";
const $91ca15859685b28b$var$ARROW_DOWN_KEY = "ArrowDown";
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE = "active";
const $91ca15859685b28b$var$CLASS_NAME_FADE$1 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$1 = "show";
const $91ca15859685b28b$var$CLASS_DROPDOWN = "dropdown";
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE = ":not(.dropdown-toggle)";
const $91ca15859685b28b$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $91ca15859685b28b$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $91ca15859685b28b$var$SELECTOR_INNER = `.nav-link${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $91ca15859685b28b$var$SELECTOR_INNER_ELEM = `${$91ca15859685b28b$var$SELECTOR_INNER}, ${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$3e41faf802a29e71 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($91ca15859685b28b$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $91ca15859685b28b$var$EventHandler.trigger(active, $91ca15859685b28b$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(innerElem, $91ca15859685b28b$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        this._activate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $91ca15859685b28b$var$ARROW_LEFT_KEY,
            $91ca15859685b28b$var$ARROW_RIGHT_KEY,
            $91ca15859685b28b$var$ARROW_UP_KEY,
            $91ca15859685b28b$var$ARROW_DOWN_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const isNext = [
            $91ca15859685b28b$var$ARROW_RIGHT_KEY,
            $91ca15859685b28b$var$ARROW_DOWN_KEY
        ].includes(event.key);
        const nextActiveElement = $91ca15859685b28b$var$getNextActiveElement(this._getChildren().filter((element)=>!$91ca15859685b28b$var$isDisabled(element)), event.target, isNext, true);
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($91ca15859685b28b$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $91ca15859685b28b$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE, $91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU, $91ca15859685b28b$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($91ca15859685b28b$var$SELECTOR_INNER_ELEM) ? elem : $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($91ca15859685b28b$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE))$91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME = "toast";
const $91ca15859685b28b$var$DATA_KEY = "bs.toast";
const $91ca15859685b28b$var$EVENT_KEY = `.${$91ca15859685b28b$var$DATA_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOVER = `mouseover${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOUT = `mouseout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN = `focusin${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSOUT = `focusout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDE = `hide${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDDEN = `hidden${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOW = `show${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOWN = `shown${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE = "fade";
const $91ca15859685b28b$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $91ca15859685b28b$var$CLASS_NAME_SHOW = "show";
const $91ca15859685b28b$var$CLASS_NAME_SHOWING = "showing";
const $91ca15859685b28b$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $91ca15859685b28b$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$8d8dc7d5f743331b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME;
    }
    // Public
    show() {
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW, $91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING, $91ca15859685b28b$var$CLASS_NAME_SHOW);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN);
        };
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$8d8dc7d5f743331b);


/*!
 * iframemanager v1.2.5
 * Author Orest Bida
 * Released under the MIT License
 */ (()=>{
    const e = "click", t = "{data-id}", o = "accept", n = "reject", c = "c-h-n", i = "c-h-b", s = "show-ph";
    let r, a, l, f, d, u = {}, m = {}, v = {}, p = "", h = {}, b = new Map(), w = "api";
    const _ = [
        "onload",
        "onerror",
        "src"
    ], g = (e)=>"function" == typeof e, $ = (e)=>"string" == typeof e, S = (e)=>a.createElement(e), T = ()=>S("div"), x = ()=>{
        const e = S("button");
        return e.type = "button", e;
    }, y = (e, t)=>e.className = t, I = (e, t)=>e.classList.add(t), P = (e, t)=>e.appendChild(t), D = (e)=>e && Object.keys(e) || [], k = (e, t)=>{
        for(const o in t)C(e, o, t[o]);
    }, E = (e)=>{
        const t = e.dataset, o = {}, n = "data-iframe-", c = e.getAttributeNames().filter((e)=>e.slice(0, 12) === n).map((e)=>e.slice(12)), i = e.querySelector("[data-placeholder]"), s = i && i.hasAttribute("data-visible");
        s && i.removeAttribute("data-visible");
        const r = i && i.cloneNode(!0);
        for (const a of c)o[a] = e.getAttribute(n + a);
        return {
            t: t.id,
            o: t.title,
            i: t.thumbnail,
            l: t.params,
            u: e,
            m: null,
            v: i,
            p: r,
            h: null,
            _: !1,
            g: !1,
            $: !0,
            S: "widget" in t,
            T: s,
            I: o
        };
    }, M = (e, t)=>{
        const o = u[e];
        if ("IntersectionObserver" in r) {
            const e = new IntersectionObserver((n)=>{
                for (const c of n)c.isIntersecting && (O(t, o[c.target.dataset.index]), e.unobserve(c.target));
            });
            for (const t of o)e.observe(t.u);
        }
    }, O = (e, o)=>{
        const n = (e)=>{
            o.h.style.backgroundImage = `url('${e}')`;
            const t = new Image();
            t.onload = ()=>I(o.h, "loaded"), t.src = e;
        };
        if ($(o.i)) "" !== o.i && n(o.i);
        else if (g(e)) e(o.t, (e)=>n(e));
        else if ($(e)) {
            const c = e.replace(t, o.t);
            n(c);
        }
    }, j = (e, o)=>{
        if (e._) return;
        if (e._ = !0, e.v) {
            const t = e.p.cloneNode(!0);
            e.v.replaceWith(t), e.v = t;
        }
        const n = o.iframe;
        if (g(o.onAccept)) return void o.onAccept(e.u, (t)=>{
            if (!(t instanceof HTMLIFrameElement)) return !1;
            k(t, n), k(t, e.I), e.P = t, e._ = !0, I(e.u, i), (!e.T || e.S) && I(e.u, s);
        });
        e.P = S("iframe");
        const c = o.iframe, r = e.l || c && c.params;
        let a = (o.embedUrl || "").replace(t, e.t);
        e.o && (e.P.title = e.o), r && $(r) && (a += "?" === r.slice(0, 1) ? r : `?${r}`), e.P.onload = ()=>{
            I(e.u, i), e.P.onload = void 0, g(n && n.onload) && n.onload(e.t, e.P);
        }, k(e.P, n), k(e.P, e.I), e.P.src = a, P(e.m, e.P);
    }, C = (e, t, o)=>{
        _.includes(t) || e.setAttribute(t, o);
    }, L = (e)=>{
        I(e.u, c), e.$ = !1;
    }, N = (e)=>{
        e.u.classList.remove(c, i, s), e.$ = !0;
    }, A = (e)=>(e = a.cookie.match(`(^|;)\\s*${e}\\s*=\\s*([^;]+)`)) ? e.pop() : "", F = (t, o, n)=>{
        const i = u[t], s = o.languages;
        i.forEach((i)=>{
            if (!i.g && s) {
                const r = s[p], l = r && r.loadBtn, f = r && r.notice, d = r && r.loadAllBtn, u = a.createElement("div"), m = T(), v = T(), h = T(), b = T();
                y(u, "cll"), i.m = u;
                const _ = ()=>{
                    L(i), j(i, o);
                };
                if (l) {
                    const t = x();
                    t.textContent = l, y(t, "c-l-b"), t.addEventListener(e, _), P(b, t);
                }
                if (d) {
                    const o = x();
                    o.textContent = d, y(o, l ? "c-la-b" : "c-l-b"), o.addEventListener(e, ()=>{
                        _(), w = e, q.acceptService(t);
                    }), P(b, o);
                }
                const g = T(), D = T(), k = T(), E = T(), M = T();
                y(g, "cc-text"), y(E, "c-bg-i"), i.h = E, y(k, "c-ld"), $(i.i) && "" === i.i || y(D, "c-bg");
                const O = i.o, C = a.createDocumentFragment();
                if (O) {
                    const e = S("span");
                    y(e, "c-tl"), e.insertAdjacentHTML("beforeend", O), P(C, e);
                }
                P(g, C), m && g.insertAdjacentHTML("beforeend", f || ""), P(v, g), y(M, "c-t-cn"), y(v, "c-n-t"), y(h, "c-n-c"), y(m, "c-nt"), y(b, "c-n-a"), P(M, v), (l || d) && P(M, b), P(h, M), P(m, h), P(D, E), P(u, m), (o.thumbnailUrl || i.i) && P(u, D), P(u, k), n && I(i.u, c), i.u.prepend(u), i.g = !0, setTimeout(()=>I(i.u, "c-an"), 20);
            }
        });
    }, G = (e, t)=>{
        const o = u[e];
        o.forEach((n)=>{
            n._ || ((e, n)=>{
                m[n] || (m[n] = new IntersectionObserver((e)=>{
                    if (v[n]) m[n].disconnect();
                    else for(let c = 0; c < e.length; ++c)e[c].isIntersecting && ((c)=>{
                        const i = e[c].target, s = i.dataset.index;
                        j(o[s], t), setTimeout(()=>{
                            L(o[s]);
                        }, 50 * c), m[n].unobserve(i);
                    })(c);
                })), m[n].observe(e);
            })(n.u, e);
        });
    }, H = (e, t)=>e in t ? e : D(t).length > 0 ? p in t ? p : D(t)[0] : void 0, J = (e, t)=>{
        const { cookie: o } = t;
        A(o.name) || ((e)=>{
            const { hostname: t, protocol: o } = location, n = e.name, c = new Date(), i = e.path || "/", s = 864e5 * (e.expiration || 182), r = e.sameSite || "Lax", l = e.domain || t;
            c.setTime(c.getTime() + s);
            let f = n + "=1" + (0 !== s ? `; Expires=${c.toUTCString()}` : "") + `; Path=${i}` + `; SameSite=${r}`;
            l.indexOf(".") > -1 && (f += `; Domain=${l}`), "https:" === o && (f += "; Secure"), a.cookie = f;
        })(o), G(e, t);
    }, V = (e, t)=>{
        const { cookie: o } = t;
        A(o.name) && ((e)=>{
            const t = e.name, o = e.path || "/", n = e.domain || location.hostname;
            a.cookie = `${t}=; Path=${o}; Domain=${n}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        })(o), ((e, t)=>{
            const o = u[e];
            for(let n = 0; n < o.length; n++)((e)=>{
                var n;
                o[e]._ && (g(t.onReject) ? (t.onReject(o[e].P, o[e].u, ()=>N(o[e])), o[e]._ = !1) : ((n = o[e]).P && n.P.remove(), n._ = !1)), N(o[e]);
            })(n);
        })(e, t);
    }, W = (e, t, o)=>{
        g(d) && d({
            eventSource: {
                type: w,
                service: e,
                action: t
            },
            changedServices: o
        });
    }, q = {
        acceptService: (e)=>{
            const t = [];
            if ("all" === e) {
                for (const e of f)v[e] = !1, b.get(e) || (b.set(e, !0), J(e, h[e]), t.push(e));
                t.length > 0 && W(e, o, t);
            } else f.includes(e) && (v[e] = !1, b.get(e) || (b.set(e, !0), J(e, h[e]), t.push(e), W(e, o, t)));
            w = "api";
        },
        rejectService: (e)=>{
            const t = [];
            if ("all" === e) {
                for (const e of f)v[e] = !0, V(e, h[e]), b.get(e) && (b.set(e, !1), t.push(e));
                t.length > 0 && W(e, n, t);
            } else f.includes(e) && (v[e] = !0, V(e, h[e]), b.get(e) && (b.set(e, !1), t.push(e), W(e, n, t)));
        },
        childExists: async ({ parent: e = r, childProperty: t, childSelector: o = "iframe", timeout: n = 1e3, maxTimeout: c = 15e3 })=>{
            let i = 1;
            const s = t ? ()=>e[t] : ()=>e.querySelector(o);
            return new Promise((e)=>{
                const t = ()=>{
                    if (s() || i++ * n > c) return e(void 0 !== s());
                    setTimeout(t, n);
                };
                t();
            });
        },
        getState: ()=>({
                services: new Map(b),
                acceptedServices: [
                    ...b
                ].filter(([, e])=>!!e).map(([e])=>e)
            }),
        getConfig: ()=>l,
        run: (e)=>{
            if (a = document, r = window, l = e, h = l.services, d = l.onChange, f = D(h), 0 === f.length) return;
            p = l.currLang;
            const t = h[f[0]].languages;
            !0 === l.autoLang ? p = H(navigator.language.slice(0, 2).toLowerCase(), t) : $(l.currLang) && (p = H(l.currLang, t));
            for (const o of f){
                const e = h[o], t = e.cookie = e.cookie || {}, n = t.name = t.name || `im_${o}`, c = A(n);
                b.set(o, !!c), u[o] = [];
                const i = a.querySelectorAll(`div[data-service="${o}"]`), s = i.length;
                if (0 !== s) {
                    for(let e = 0; e < s; e++)i[e].dataset.index = e, u[o].push(E(i[e]));
                    c ? (F(o, e, !0), G(o, e)) : F(o, e, !1), M(o, e.thumbnailUrl);
                }
            }
        }
    }, z = "iframemanager";
    "undefined" == typeof window || g(window[z]) || (window[z] = ()=>q);
})();


/*!
 * CookieConsent v2.9.0
 * https://www.github.com/orestbida/cookieconsent
 * Author Orest Bida
 * Released under the MIT License
 */ !function() {
    "use strict";
    var n = "initCookieConsent";
    "undefined" != typeof window && "function" != typeof window[n] && (window[n] = function(n) {
        var t, e, o, i, r, a, c, f, u, d, v, l, s, p, b, m, y, g, h, _, w, k, x, S, J, O, j, N, T, D, C, U, z, E, I, L = {
            mode: "opt-in",
            current_lang: "en",
            auto_language: null,
            autorun: !0,
            page_scripts: !0,
            hide_from_bots: !0,
            cookie_name: "cc_cookie",
            cookie_expiration: 182,
            cookie_domain: location.hostname,
            cookie_path: "/",
            cookie_same_site: "Lax",
            use_rfc_cookie: !1,
            autoclear_cookies: !0,
            revision: 0,
            script_selector: "data-cookiecategory"
        }, M = {}, R = {}, A = null, G = !0, H = !1, P = !1, q = !1, B = !1, F = !0, K = [], Q = !1, V = [], W = [], X = [], Y = !1, Z = [], $ = [], nn = [], tn = [], en = [], on = document.documentElement, rn = function(n) {
            "number" == typeof (t = n).cookie_expiration && (L.cookie_expiration = t.cookie_expiration), "number" == typeof t.cookie_necessary_only_expiration && (L.cookie_necessary_only_expiration = t.cookie_necessary_only_expiration), "boolean" == typeof t.autorun && (L.autorun = t.autorun), "string" == typeof t.cookie_domain && (L.cookie_domain = t.cookie_domain), "string" == typeof t.cookie_same_site && (L.cookie_same_site = t.cookie_same_site), "string" == typeof t.cookie_path && (L.cookie_path = t.cookie_path), "string" == typeof t.cookie_name && (L.cookie_name = t.cookie_name), "function" == typeof t.onAccept && (v = t.onAccept), "function" == typeof t.onFirstAction && (s = t.onFirstAction), "function" == typeof t.onChange && (l = t.onChange), "opt-out" === t.mode && (L.mode = "opt-out"), "number" == typeof t.revision && (t.revision > -1 && (L.revision = t.revision), B = !0), "boolean" == typeof t.autoclear_cookies && (L.autoclear_cookies = t.autoclear_cookies), !0 === t.use_rfc_cookie && (L.use_rfc_cookie = !0), "boolean" == typeof t.hide_from_bots && (L.hide_from_bots = t.hide_from_bots), L.hide_from_bots && (Y = navigator && (navigator.userAgent && /bot|crawl|spider|slurp|teoma/i.test(navigator.userAgent) || navigator.webdriver)), L.page_scripts = !0 === t.page_scripts, "browser" === t.auto_language || !0 === t.auto_language ? L.auto_language = "browser" : "document" === t.auto_language && (L.auto_language = "document"), L.auto_language, L.current_lang = sn(t.languages, t.current_lang);
        }, an = function(n) {
            for(var t = "accept-", e = c("c-settings"), o = c(t + "all"), i = c(t + "necessary"), r = c(t + "custom"), a = 0; a < e.length; a++)e[a].setAttribute("aria-haspopup", "dialog"), wn(e[a], "click", function(n) {
                n.preventDefault(), M.showSettings(0);
            });
            for(a = 0; a < o.length; a++)wn(o[a], "click", function(n) {
                f(n, "all");
            });
            for(a = 0; a < r.length; a++)wn(r[a], "click", function(n) {
                f(n);
            });
            for(a = 0; a < i.length; a++)wn(i[a], "click", function(n) {
                f(n, []);
            });
            function c(t) {
                return (n || document).querySelectorAll('[data-cc="' + t + '"]');
            }
            function f(n, t) {
                n.preventDefault(), M.accept(t), M.hideSettings(), M.hide();
            }
        }, cn = function(n, t) {
            return t.hasOwnProperty(n) ? n : kn(t).length > 0 ? t.hasOwnProperty(L.current_lang) ? L.current_lang : kn(t)[0] : void 0;
        }, fn = function(n) {
            if (!0 === t.force_consent && xn(on, "force--consent"), !h) {
                h = ln("div");
                var e = ln("div"), o = ln("div");
                h.id = "cm", e.id = "c-inr-i", o.id = "cm-ov", h.tabIndex = -1, h.setAttribute("role", "dialog"), h.setAttribute("aria-modal", "true"), h.setAttribute("aria-hidden", "false"), h.setAttribute("aria-labelledby", "c-ttl"), h.setAttribute("aria-describedby", "c-txt"), g.appendChild(h), g.appendChild(o), h.style.visibility = o.style.visibility = "hidden", o.style.opacity = 0;
            }
            var i = t.languages[n].consent_modal.title;
            i && (_ || ((_ = ln("div")).id = "c-ttl", _.setAttribute("role", "heading"), _.setAttribute("aria-level", "2"), e.appendChild(_)), _.innerHTML = i);
            var r = t.languages[n].consent_modal.description;
            B && (r = F ? r.replace("{{revision_message}}", "") : r.replace("{{revision_message}}", t.languages[n].consent_modal.revision_message || "")), w || ((w = ln("div")).id = "c-txt", e.appendChild(w)), w.innerHTML = r;
            var a, c = t.languages[n].consent_modal.primary_btn, f = t.languages[n].consent_modal.secondary_btn;
            c && (k || ((k = ln("button")).id = "c-p-bn", k.className = "c-bn", k.appendChild(On(1)), "accept_all" === c.role && (a = "all"), wn(k, "click", function() {
                M.hide(), M.accept(a);
            })), k.firstElementChild.innerHTML = t.languages[n].consent_modal.primary_btn.text), f && (x || ((x = ln("button")).id = "c-s-bn", x.className = "c-bn c_link", x.appendChild(On(1)), "accept_necessary" === f.role ? wn(x, "click", function() {
                M.hide(), M.accept([]);
            }) : wn(x, "click", function() {
                M.showSettings(0);
            })), x.firstElementChild.innerHTML = t.languages[n].consent_modal.secondary_btn.text);
            var u = t.gui_options;
            J || ((J = ln("div")).id = "c-inr", J.appendChild(e)), S || ((S = ln("div")).id = "c-bns", u && u.consent_modal && !0 === u.consent_modal.swap_buttons ? (f && S.appendChild(x), c && S.appendChild(k), S.className = "swap") : (c && S.appendChild(k), f && S.appendChild(x)), (c || f) && J.appendChild(S), h.appendChild(J)), H = !0, an(J);
        }, un = function(n) {
            if (O) (C = ln("div")).id = "s-bl";
            else {
                (O = ln("div")).tabIndex = -1;
                var e = ln("div"), o = ln("div"), i = ln("div");
                j = ln("div"), N = ln("div");
                var r = ln("div");
                (T = ln("button")).appendChild(On(2));
                var a = ln("div");
                D = ln("div");
                var c = ln("div");
                wn(i, "click", function(n) {
                    q && !j.contains(n.target) && M.hideSettings();
                }, !0), O.id = "s-cnt", e.id = "c-vln", i.id = "c-s-in", o.id = "cs", N.id = "s-ttl", j.id = "s-inr", r.id = "s-hdr", D.id = "s-bl", T.id = "s-c-bn", c.id = "cs-ov", a.id = "s-c-bnc", T.className = "c-bn", O.setAttribute("role", "dialog"), O.setAttribute("aria-modal", "true"), O.setAttribute("aria-hidden", "true"), O.setAttribute("aria-labelledby", "s-ttl"), N.setAttribute("role", "heading"), O.style.visibility = c.style.visibility = "hidden", c.style.opacity = 0, a.appendChild(T), wn(document, "keydown", function(n) {
                    27 === n.keyCode && q && M.hideSettings();
                }, !0), wn(T, "click", function() {
                    M.hideSettings();
                });
            }
            var f = t.languages[n].settings_modal;
            T.setAttribute("aria-label", f.close_btn_label || "Close"), d = f.blocks, u = f.cookie_table_headers;
            var v = f.cookie_table_caption, l = d.length;
            N.innerHTML = f.title;
            for(var s = 0; s < l; ++s){
                var p = d[s].title, b = d[s].description, m = d[s].toggle, y = d[s].cookie_table, h = !0 === t.remove_cookie_tables, _ = !!b || !h && !!y, w = ln("div"), k = ln("div");
                if (b) {
                    var x = ln("div");
                    x.className = "p", x.insertAdjacentHTML("beforeend", b);
                }
                var S = ln("div");
                if (S.className = "title", w.className = "c-bl", k.className = "desc", void 0 !== m) {
                    var J = "c-ac-" + s, L = ln(_ ? "button" : "div"), A = ln("label"), H = ln("input"), P = ln("span"), B = ln("span"), F = ln("span"), K = ln("span");
                    L.className = _ ? "b-tl exp" : "b-tl", A.className = "b-tg", H.className = "c-tgl", F.className = "on-i", K.className = "off-i", P.className = "c-tg", B.className = "t-lb", _ && (L.setAttribute("aria-expanded", "false"), L.setAttribute("aria-controls", J)), H.type = "checkbox", P.setAttribute("aria-hidden", "true");
                    var Q = m.value;
                    H.value = Q, B.textContent = p, L.insertAdjacentHTML("beforeend", p), S.appendChild(L), P.appendChild(F), P.appendChild(K), G ? m.enabled ? (H.checked = !0, !C && nn.push(!0), m.enabled && !C && X.push(Q)) : !C && nn.push(!1) : vn(R.categories, Q) > -1 ? (H.checked = !0, !C && nn.push(!0)) : !C && nn.push(!1), !C && tn.push(Q), m.readonly && (H.disabled = !0, xn(P, "c-ro"), !C && en.push(Q)), xn(k, "b-acc"), xn(S, "b-bn"), xn(w, "b-ex"), k.id = J, k.setAttribute("aria-hidden", "true"), A.appendChild(H), A.appendChild(P), A.appendChild(B), S.appendChild(A), _ && function(n, t, e) {
                        wn(L, "click", function() {
                            Jn(t, "act") ? (Sn(t, "act"), e.setAttribute("aria-expanded", "false"), n.setAttribute("aria-hidden", "true")) : (xn(t, "act"), e.setAttribute("aria-expanded", "true"), n.setAttribute("aria-hidden", "false"));
                        }, !1);
                    }(k, w, L);
                } else if (p) {
                    var V = ln("div");
                    V.className = "b-tl", V.setAttribute("role", "heading"), V.setAttribute("aria-level", "3"), V.insertAdjacentHTML("beforeend", p), S.appendChild(V);
                }
                if (p && w.appendChild(S), b && k.appendChild(x), !h && void 0 !== y) {
                    for(var W = document.createDocumentFragment(), Y = 0; Y < u.length; ++Y){
                        var Z = ln("th"), $ = u[Y];
                        if (Z.setAttribute("scope", "col"), $) {
                            var on = $ && kn($)[0];
                            Z.textContent = u[Y][on], W.appendChild(Z);
                        }
                    }
                    var rn = ln("tr");
                    rn.appendChild(W);
                    var an = ln("thead");
                    an.appendChild(rn);
                    var cn = ln("table");
                    if (v) {
                        var fn = ln("caption");
                        fn.innerHTML = v, cn.appendChild(fn);
                    }
                    cn.appendChild(an);
                    for(var un = document.createDocumentFragment(), dn = 0; dn < y.length; dn++){
                        for(var sn = ln("tr"), pn = 0; pn < u.length; ++pn)if ($ = u[pn]) {
                            on = kn($)[0];
                            var bn = ln("td");
                            bn.insertAdjacentHTML("beforeend", y[dn][on]), bn.setAttribute("data-column", $[on]), sn.appendChild(bn);
                        }
                        un.appendChild(sn);
                    }
                    var mn = ln("tbody");
                    mn.appendChild(un), cn.appendChild(mn), k.appendChild(cn);
                }
                (m && p || !m && (p || b)) && (w.appendChild(k), C ? C.appendChild(w) : D.appendChild(w));
            }
            U || ((U = ln("div")).id = "s-bns"), E || ((E = ln("button")).id = "s-all-bn", E.className = "c-bn", U.appendChild(E), wn(E, "click", function() {
                M.accept("all"), M.hideSettings(), M.hide();
            })), E.innerHTML = f.accept_all_btn;
            var yn = f.reject_all_btn;
            if (yn && (I || ((I = ln("button")).id = "s-rall-bn", I.className = "c-bn", wn(I, "click", function() {
                M.accept([]), M.hideSettings(), M.hide();
            }), j.className = "bns-t", U.appendChild(I)), I.innerHTML = yn), z || ((z = ln("button")).id = "s-sv-bn", z.className = "c-bn", U.appendChild(z), wn(z, "click", function() {
                M.accept(), M.hideSettings(), M.hide();
            })), z.innerHTML = f.save_settings_btn, C) return j.replaceChild(C, D), void (D = C);
            r.appendChild(N), r.appendChild(a), j.appendChild(r), j.appendChild(D), j.appendChild(U), i.appendChild(j), o.appendChild(i), e.appendChild(o), O.appendChild(e), g.appendChild(O), g.appendChild(c);
        };
        M.updateLanguage = function(n, e) {
            if ("string" == typeof n) {
                var o = cn(n, t.languages);
                return (o !== L.current_lang || !0 === e) && (L.current_lang = o, H && fn(o), un(o), !0);
            }
        };
        var dn = function(n) {
            var t = d.length, e = -1;
            Q = !1;
            var o = hn("", "all"), i = [
                L.cookie_domain,
                "." + L.cookie_domain
            ];
            if ("www." === L.cookie_domain.slice(0, 4)) {
                var r = L.cookie_domain.substr(4);
                i.push(r), i.push("." + r);
            }
            for(var a = 0; a < t; a++){
                var c = d[a];
                if (c.hasOwnProperty("toggle")) {
                    var f = vn(K, c.toggle.value) > -1;
                    if (!nn[++e] && c.hasOwnProperty("cookie_table") && (n || f)) {
                        var v = c.cookie_table, l = kn(u[0])[0], s = v.length;
                        "on_disable" === c.toggle.reload && f && (Q = !0);
                        for(var p = 0; p < s; p++){
                            var b = i, m = v[p], y = [], g = m[l], h = m.is_regex || !1, _ = m.domain || null, w = m.path || !1;
                            if (_ && (b = [
                                _,
                                "." + _
                            ]), h) for(var k = 0; k < o.length; k++)o[k].match(g) && y.push(o[k]);
                            else {
                                var x = vn(o, g);
                                x > -1 && y.push(o[x]);
                            }
                            y.length > 0 && (_n(y, w, b), "on_clear" === c.toggle.reload && (Q = !0));
                        }
                    }
                }
            }
        }, vn = function(n, t) {
            return n.indexOf(t);
        }, ln = function(n) {
            var t = document.createElement(n);
            return "button" === n && t.setAttribute("type", n), t;
        }, sn = function(n, t) {
            return "browser" === L.auto_language ? cn(pn(), n) : "document" === L.auto_language ? cn(document.documentElement.lang, n) : "string" == typeof t ? L.current_lang = cn(t, n) : (L.current_lang, L.current_lang);
        }, pn = function() {
            var n = navigator.language || navigator.browserLanguage;
            return n.length > 2 && (n = n[0] + n[1]), n.toLowerCase();
        };
        M.allowedCategory = function(n) {
            if (G && "opt-in" !== L.mode) t = X;
            else var t = JSON.parse(hn(L.cookie_name, "one", !0) || "{}").categories || [];
            return vn(t, n) > -1;
        }, M.run = function(t) {
            if (!document.getElementById("cc_div")) {
                if (rn(t), Y) return;
                R = JSON.parse(hn(L.cookie_name, "one", !0) || "{}");
                var c = void 0 !== (i = R.consent_uuid);
                if ((e = R.consent_date) && (e = new Date(e)), (o = R.last_consent_update) && (o = new Date(o)), A = void 0 !== R.data ? R.data : null, B && R.revision !== L.revision && (F = !1), H = G = !(c && F && e && o && i), function() {
                    (y = ln("div")).id = "cc--main", y.style.position = "fixed", y.innerHTML = '<div id="cc_div" class="cc_div"></div>', g = y.children[0];
                    var t = L.current_lang;
                    H && fn(t), un(t), (n || document.body).appendChild(y);
                }(), function() {
                    var n = [
                        "[href]",
                        "button",
                        "input",
                        "details",
                        '[tabindex="0"]'
                    ];
                    function t(t, e) {
                        var o = !1, i = !1;
                        try {
                            for(var r, a = t.querySelectorAll(n.join(':not([tabindex="-1"]), ')), c = a.length, f = 0; f < c;)r = a[f].getAttribute("data-focus"), i || "1" !== r ? "0" === r && (o = a[f], i || "0" === a[f + 1].getAttribute("data-focus") || (i = a[f + 1])) : i = a[f], f++;
                        } catch (e) {
                            return t.querySelectorAll(n.join(", "));
                        }
                        e[0] = a[0], e[1] = a[a.length - 1], e[2] = o, e[3] = i;
                    }
                    t(j, $), H && t(h, Z);
                }(), function(n, t) {
                    if ("object" == typeof n) {
                        var e = n.consent_modal, o = n.settings_modal;
                        H && e && i(h, [
                            "box",
                            "bar",
                            "cloud"
                        ], [
                            "top",
                            "middle",
                            "bottom"
                        ], [
                            "zoom",
                            "slide"
                        ], e.layout, e.position, e.transition), o && i(O, [
                            "bar"
                        ], [
                            "left",
                            "right"
                        ], [
                            "zoom",
                            "slide"
                        ], o.layout, o.position, o.transition);
                    }
                    function i(n, t, e, o, i, r, a) {
                        if (r = r && r.split(" ") || [], vn(t, i) > -1 && (xn(n, i), ("bar" !== i || "middle" !== r[0]) && vn(e, r[0]) > -1)) for(var c = 0; c < r.length; c++)xn(n, r[c]);
                        vn(o, a) > -1 && xn(n, a);
                    }
                }(t.gui_options), an(), L.autorun && H && M.show(t.delay || 0), setTimeout(function() {
                    xn(y, "c--anim");
                }, 30), setTimeout(function() {
                    wn(document, "keydown", function(n) {
                        if ("Tab" === n.key && (P || q) && r) {
                            var t = Tn();
                            n.shiftKey ? t !== r[0] && a.contains(t) || (n.preventDefault(), jn(r[1])) : t !== r[1] && a.contains(t) || (n.preventDefault(), jn(r[0]));
                        }
                    });
                }, 100), G) "opt-out" === L.mode && (L.mode, bn(X));
                else {
                    var f = "boolean" == typeof R.rfc_cookie;
                    (!f || f && R.rfc_cookie !== L.use_rfc_cookie) && (R.rfc_cookie = L.use_rfc_cookie, gn(L.cookie_name, JSON.stringify(R))), p = yn(mn()), bn(), "function" == typeof v && v(R);
                }
            }
        };
        var bn = function(n) {
            if (L.page_scripts) {
                var t = document.querySelectorAll("script[" + L.script_selector + "]"), e = n || R.categories || [], o = function(n, t) {
                    if (t < n.length) {
                        var i = n[t], r = i.getAttribute(L.script_selector);
                        if (vn(e, r) > -1) {
                            i.type = i.getAttribute("data-type") || "text/javascript", i.removeAttribute(L.script_selector);
                            var a = i.getAttribute("data-src");
                            a && i.removeAttribute("data-src");
                            var c = ln("script");
                            if (c.textContent = i.innerHTML, function(n, t) {
                                for(var e = t.attributes, o = e.length, i = 0; i < o; i++){
                                    var r = e[i].nodeName;
                                    n.setAttribute(r, t[r] || t.getAttribute(r));
                                }
                            }(c, i), a ? c.src = a : a = i.src, a && (c.readyState ? c.onreadystatechange = function() {
                                "loaded" !== c.readyState && "complete" !== c.readyState || (c.onreadystatechange = null, o(n, ++t));
                            } : c.onload = function() {
                                c.onload = null, o(n, ++t);
                            }), i.parentNode.replaceChild(c, i), a) return;
                        }
                        o(n, ++t);
                    }
                };
                o(t, 0);
            }
        };
        M.set = function(n, t) {
            return "data" === n && function(n, t) {
                var e = !1;
                if ("update" === t) {
                    var o = typeof (A = M.get("data")) == typeof n;
                    if (o && "object" == typeof A) for(var i in !A && (A = {}), n)A[i] !== n[i] && (A[i] = n[i], e = !0);
                    else !o && A || A === n || (A = n, e = !0);
                } else A = n, e = !0;
                return e && (R.data = A, gn(L.cookie_name, JSON.stringify(R))), e;
            }(t.value, t.mode);
        }, M.get = function(n, t) {
            return JSON.parse(hn(t || L.cookie_name, "one", !0) || "{}")[n];
        }, M.getConfig = function(n) {
            return L[n] || t[n];
        };
        var mn = function() {
            return V = R.categories || [], W = tn.filter(function(n) {
                return -1 === vn(V, n);
            }), {
                accepted: V,
                rejected: W
            };
        }, yn = function(n) {
            var t = "custom", e = en.length;
            return n.accepted.length === tn.length ? t = "all" : n.accepted.length === e && (t = "necessary"), t;
        };
        M.getUserPreferences = function() {
            var n = mn();
            return {
                accept_type: yn(n),
                accepted_categories: n.accepted,
                rejected_categories: n.rejected
            };
        }, M.loadScript = function(n, t, e) {
            var o = "function" == typeof t;
            if (document.querySelector('script[src="' + n + '"]')) o && t();
            else {
                var i = ln("script");
                if (e && e.length > 0) for(var r = 0; r < e.length; ++r)e[r] && i.setAttribute(e[r].name, e[r].value);
                o && (i.onload = t), i.src = n, document.head.appendChild(i);
            }
        }, M.updateScripts = function() {
            bn();
        }, M.show = function(n, t) {
            !0 === t && fn(L.current_lang), H && (b = Tn(), r = Z, a = h, P = !0, h.removeAttribute("aria-hidden"), setTimeout(function() {
                xn(on, "show--consent");
            }, n > 0 ? n : t ? 30 : 0));
        }, M.hide = function() {
            H && (P = !1, jn(c), h.setAttribute("aria-hidden", "true"), Sn(on, "show--consent"), jn(b), b = null);
        }, M.showSettings = function(n) {
            q = !0, O.removeAttribute("aria-hidden"), P ? m = Tn() : b = Tn(), a = O, r = $, setTimeout(function() {
                xn(on, "show--settings");
            }, n > 0 ? n : 0);
        }, M.hideSettings = function() {
            q = !1, Nn(), jn(f), O.setAttribute("aria-hidden", "true"), Sn(on, "show--settings"), P ? (jn(m), m = null, a = h, r = Z) : (jn(b), b = null);
        }, M.accept = function(n, t) {
            var r = n || void 0, a = t || [], c = [];
            if (r) {
                if ("object" == typeof r && "number" == typeof r.length) for(var f = 0; f < r.length; f++)-1 !== vn(tn, r[f]) && c.push(r[f]);
                else "string" == typeof r && ("all" === r ? c = tn.slice() : -1 !== vn(tn, r) && c.push(r));
            } else c = function() {
                for(var n = document.querySelectorAll(".c-tgl") || [], t = [], e = 0; e < n.length; e++)n[e].checked && t.push(n[e].value);
                return t;
            }();
            if (a.length >= 1) for(f = 0; f < a.length; f++)c = c.filter(function(n) {
                return n !== a[f];
            });
            for(f = 0; f < tn.length; f++)!0 === en.includes(tn[f]) && -1 === vn(c, tn[f]) && c.push(tn[f]);
            !function(n) {
                K = [];
                var t = O.querySelectorAll(".c-tgl") || [];
                if (t.length > 0) for(var r = 0; r < t.length; r++)-1 !== vn(n, tn[r]) ? (t[r].checked = !0, nn[r] || (K.push(tn[r]), nn[r] = !0)) : (t[r].checked = !1, nn[r] && (K.push(tn[r]), nn[r] = !1));
                !G && L.autoclear_cookies && K.length > 0 && dn(), e || (e = new Date()), i || (i = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function(n) {
                    try {
                        return (n ^ (window.crypto || window.msCrypto).getRandomValues(new Uint8Array(1))[0] & 15 >> n / 4).toString(16);
                    } catch (n) {
                        return "";
                    }
                })), R = {
                    categories: n,
                    level: n,
                    revision: L.revision,
                    data: A,
                    rfc_cookie: L.use_rfc_cookie,
                    consent_date: e.toISOString(),
                    consent_uuid: i
                }, (G || K.length > 0) && (F = !0, o = o ? new Date() : e, R.last_consent_update = o.toISOString(), p = yn(mn()), gn(L.cookie_name, JSON.stringify(R)), bn()), G && (L.autoclear_cookies && dn(!0), "function" == typeof s && s(M.getUserPreferences(), R), "function" == typeof v && v(R), G = !1, "opt-in" === L.mode) || ("function" == typeof l && K.length > 0 && l(R, K), Q && location.reload());
            }(c);
        }, M.eraseCookies = function(n, t, e) {
            var o = [], i = e ? [
                e,
                "." + e
            ] : [
                L.cookie_domain,
                "." + L.cookie_domain
            ];
            if ("object" == typeof n && n.length > 0) for(var r = 0; r < n.length; r++)this.validCookie(n[r]) && o.push(n[r]);
            else this.validCookie(n) && o.push(n);
            _n(o, t, i);
        };
        var gn = function(n, t) {
            var e = L.cookie_expiration;
            "number" == typeof L.cookie_necessary_only_expiration && "necessary" === p && (e = L.cookie_necessary_only_expiration), t = L.use_rfc_cookie ? encodeURIComponent(t) : t;
            var o = new Date();
            o.setTime(o.getTime() + 24 * e * 3600000);
            var i = n + "=" + (t || "") + "; expires=" + o.toUTCString() + "; Path=" + L.cookie_path + ";";
            i += " SameSite=" + L.cookie_same_site + ";", location.hostname.indexOf(".") > -1 && L.cookie_domain && (i += " Domain=" + L.cookie_domain + ";"), "https:" === location.protocol && (i += " Secure;"), document.cookie = i;
        }, hn = function(n, t, e) {
            var o;
            if ("one" === t) {
                if ((o = (o = document.cookie.match("(^|;)\\s*" + n + "\\s*=\\s*([^;]+)")) ? e ? o.pop() : n : "") && n === L.cookie_name) {
                    try {
                        o = JSON.parse(o);
                    } catch (n) {
                        try {
                            o = JSON.parse(decodeURIComponent(o));
                        } catch (n) {
                            o = {};
                        }
                    }
                    o = JSON.stringify(o);
                }
            } else if ("all" === t) {
                var i = document.cookie.split(/;\s*/);
                o = [];
                for(var r = 0; r < i.length; r++)o.push(i[r].split("=")[0]);
            }
            return o;
        }, _n = function(n, t, e) {
            for(var o = t || "/", i = 0; i < n.length; i++){
                for(var r = 0; r < e.length; r++)document.cookie = n[i] + "=; path=" + o + (0 == e[r].indexOf(".") ? "; domain=" + e[r] : "") + "; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                n[i];
            }
        };
        M.validCookie = function(n) {
            return "" !== hn(n, "one", !0);
        };
        var wn = function(n, t, e, o) {
            n.addEventListener(t, e, !0 === o && {
                passive: !0
            });
        }, kn = function(n) {
            if ("object" == typeof n) return Object.keys(n);
        }, xn = function(n, t) {
            n.classList.add(t);
        }, Sn = function(n, t) {
            n.classList.remove(t);
        }, Jn = function(n, t) {
            return n.classList.contains(t);
        }, On = function(n) {
            var t = ln("span");
            return t.tabIndex = -1, 1 === n ? c = t : f = t, t;
        }, jn = function(n) {
            n && n instanceof HTMLElement && n.focus();
        }, Nn = function() {
            for(var n = j.querySelectorAll(".c-tgl"), t = 0; t < n.length; t++){
                var e = n[t].value, o = en.includes(e);
                n[t].checked = o || M.allowedCategory(e);
            }
        }, Tn = function() {
            return document.activeElement;
        };
        return M;
    });
}();


// obtain iframemanager object
var $4871225280d85a28$var$manager = iframemanager();
// obtain cookieconsent plugin
var $4871225280d85a28$var$cc = initCookieConsent();
$4871225280d85a28$var$manager.run({
    currLang: "de",
    services: {
        airtable: {
            embedUrl: "https://airtable.com/embed/appuemWY2xynXWJKt/shrB9yLVSxeZ9yDMr?backgroundColor=purple",
            iframe: {
                allow: "accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;"
            },
            languages: {
                de: {
                    notice: 'Dieser Inhalt wird von einem Drittanbieter gehostet. Durch das Anzeigen des externen Inhalts akzeptieren Sie die Gesch\xe4ftsbedingungen von Airtable <a rel="noreferrer noopener" href="https://www.airtable.com/privacy" target="_blank">Datenschutzerkl\xe4rung</a> von airtable.com',
                    loadBtn: "Anmelde Formular einmalig laden",
                    loadAllBtn: "Ab jetzt immer laden"
                }
            },
            cookie: {
                name: "im_airtable"
            }
        },
        googlemaps: {
            embedUrl: "https://www.google.com/maps/embed?pb={data-id}",
            iframe: {
                allow: "picture-in-picture; fullscreen;"
            },
            languages: {
                de: {
                    notice: 'Dieser Inhalt wird von einem Drittanbieter gehostet. Durch das Anzeigen des externen Inhalts akzeptieren Sie die Gesch\xe4ftsbedingungen von Google Maps <a rel="noreferrer noopener" href="https://cloud.google.com/maps-platform/terms" target="_blank">Datenschutzerkl\xe4rung</a> von Google Maps.',
                    loadBtn: "Google Maps einmalig laden",
                    loadAllBtn: "Ab jetzt immer laden"
                }
            }
        }
    }
});
// run plugin with your configuration
$4871225280d85a28$var$cc.run({
    current_lang: "de",
    autoclear_cookies: true,
    page_scripts: true,
    mode: "opt-out",
    // delay: 0,                               // default: 0
    // auto_language: null                     // default: null; could also be 'browser' or 'document'
    // autorun: true,                          // default: true
    // force_consent: false,                   // default: false
    // hide_from_bots: true,                   // default: true
    // remove_cookie_tables: false             // default: false
    // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
    // cookie_expiration: 182,                 // default: 182 (days)
    // cookie_necessary_only_expiration: 182   // default: disabled
    // cookie_domain: location.hostname,       // default: current domain
    // cookie_path: '/',                       // default: root
    // cookie_same_site: 'Lax',                // default: 'Lax'
    // use_rfc_cookie: false,                  // default: false
    // revision: 0,                            // default: 0
    gui_options: {
        consent_modal: {
            layout: "cloud",
            position: "bottom center",
            transition: "slide",
            swap_buttons: false
        },
        settings_modal: {
            layout: "box",
            position: "left",
            transition: "slide"
        }
    },
    onFirstAction: function(user_preferences, cookie) {
    // callback triggered only once
    },
    onAccept: function(cookie) {
        // If analytics category is disabled => load all iframes automatically
        if ($4871225280d85a28$var$cc.allowedCategory("analytics")) {
            console.log("iframemanager: loading all iframes");
            $4871225280d85a28$var$manager.acceptService("all");
        }
    },
    onChange: function(cookie, changed_preferences) {
        // If analytics category is disabled => ask for permission to load iframes
        if (!$4871225280d85a28$var$cc.allowedCategory("analytics")) {
            console.log("iframemanager: disabling all iframes");
            $4871225280d85a28$var$manager.rejectService("all");
        } else {
            console.log("iframemanager: loading all iframes");
            $4871225280d85a28$var$manager.acceptService("all");
        }
    },
    languages: {
        de: {
            consent_modal: {
                title: "Wir verwenden Cookies!",
                description: 'Hallo, diese Website verwendet unverzichtbare Cookies, um ihre ordnungsgem\xe4\xdfe Funktion sicherzustellen, sowie Tracking-Cookies, um zu verstehen, wie Sie mit ihr interagieren. Letztere werden erst nach Ihrer Zustimmung gesetzt. <button type="button" data-cc="c-settings" class="cc-link"> Einstellungen ausw\xe4hlen</button>',
                primary_btn: {
                    text: "Alle akzeptieren",
                    role: "accept_all"
                },
                secondary_btn: {
                    text: "Alle verweigern",
                    role: "accept_necessary"
                }
            },
            settings_modal: {
                title: "Cookie Einstellungen",
                save_settings_btn: "Einstellungen speichern",
                accept_all_btn: "Alle akteptieren",
                reject_all_btn: "Alle verweigern",
                close_btn_label: "Schlie\xdfen",
                serviceCounterLabel: "Service|Services",
                cookie_table_headers: [
                    {
                        col1: "Name"
                    },
                    {
                        col2: "Service"
                    },
                    {
                        col3: "Beschreibung"
                    }
                ],
                blocks: [
                    {
                        title: "Verwendung von Cookies \uD83D\uDCE2",
                        description: 'Ich verwende Cookies, um die grundlegenden Funktionen der Website sicherzustellen und Ihr Online-Erlebnis zu verbessern. Sie k\xf6nnen f\xfcr jede Kategorie w\xe4hlen, ob Sie sie aktivieren oder deaktivieren m\xf6chten, wann immer Sie m\xf6chten. F\xfcr weitere Details zu Cookies und anderen sensiblen Daten lesen Sie bitte die vollst\xe4ndige Datenschutzerkl\xe4rung. <a href="/privacy" class="cc-link">Datenschutzerkl\xe4rung</a>.'
                    },
                    {
                        title: "Unbedingt erforderliche Cookies",
                        description: "Diese Cookies sind f\xfcr das ordnungsgem\xe4\xdfe Funktionieren meiner Website unerl\xe4sslich. Ohne diese Cookies w\xfcrde die Website nicht ordnungsgem\xe4\xdf funktionieren.",
                        toggle: {
                            value: "necessary",
                            enabled: true,
                            readonly: true
                        }
                    },
                    {
                        title: "Analytics Cookies",
                        description: "Diese Cookies erm\xf6glichen es der Website, sich an die Entscheidungen zu erinnern, die Sie in der Vergangenheit getroffen haben.",
                        linkedCategory: "analytics",
                        toggle: {
                            value: "analytics",
                            enabled: false,
                            readonly: false
                        },
                        cookie_table: [
                            // list of all expected cookies
                            {
                                col1: "__Host-airtable-session",
                                col2: "Airtable",
                                col3: "Session ID for Airtable platform"
                            },
                            {
                                col1: "__Host-airtable-session.sig",
                                col2: "Airtable",
                                col3: "Session ID for Airtable platform"
                            },
                            {
                                col1: "AWSELB",
                                col2: "Airtable",
                                col3: "Load Balancing"
                            },
                            {
                                col1: "AWSELBCORS",
                                col2: "Airtable",
                                col3: "Load Balancing"
                            },
                            {
                                col1: "brw",
                                col2: "Airtable",
                                col3: "Session ID for debugging"
                            },
                            {
                                col1: "_ga",
                                col2: "Airtable",
                                col3: "Google Analytics cookies used for analytics and service improvement"
                            },
                            {
                                col1: "_gat",
                                col2: "Airtable",
                                col3: "Google Analytics cookies used for analytics and service improvement"
                            },
                            {
                                col1: "_gat_UA-nnnnnnn-nn",
                                col2: "Airtable",
                                col3: "This is a pattern type cookie set by Google Analytics, where the pattern element on the name contains the unique identity number of the account or website it relates to. It appears to be a variation of the _gat cookie which is used to limit the amount of data recorded by Google on high traffic volume websites."
                            },
                            {
                                col1: "_gat_xxxxxxxxxxxxxxxxxxxxxxxxxx",
                                col2: "Airtable",
                                col3: "Google Analytics cookies used for analytics and service improvement"
                            },
                            {
                                col1: "_gid",
                                col2: "Airtable",
                                col3: "Google Analytics cookies used for analytics and service improvement"
                            },
                            {
                                col1: "_mkto_trk",
                                col2: "Airtable",
                                col3: "This cookie is associated with an email marketing service provided by Marketo. This tracking cookie allows a website to link visitor behaviour to the recipient of an email marketing campaign, to measure campaign effectiveness."
                            },
                            {
                                col1: "amplitude_cookie_test",
                                col2: "Airtable",
                                col3: "Amplitude cookies used to track traffic to improve the performance of our website."
                            },
                            {
                                col1: "amplitude_id_01c5c9182d4beaee719619af5db39310airtable.com",
                                col2: "Airtable",
                                col3: "Amplitude cookies to identify unique users visits in order to keep accurate web analytics."
                            },
                            {
                                col1: "amplitude_testairtable.com",
                                col2: "Airtable",
                                col3: "Amplitude cookies to identify unique users visits in order to keep accurate web analytics."
                            },
                            {
                                col1: "lightstep_guid%2FsharedForm",
                                col2: "Airtable",
                                col3: "Session ID"
                            },
                            {
                                col1: "lightstep_guid%2FsharedViewOrApp",
                                col2: "Airtable",
                                col3: "Session ID"
                            },
                            {
                                col1: "lightstep_session_id",
                                col2: "Airtable",
                                col3: "Session ID"
                            },
                            {
                                col1: "mv",
                                col2: "Airtable",
                                col3: "Airtable uses this cookie to track website analytics and improve the performance of our website."
                            },
                            {
                                col1: "optimizelyDomainTestCookie",
                                col2: "Airtable",
                                col3: "Optimizely cookies to identify unique users visits and improve website functionality."
                            },
                            {
                                col1: "optimizelyEndUserId",
                                col2: "Airtable",
                                col3: "Optimizely cookies to identify unique users visits and improve website functionality."
                            },
                            {
                                col1: "optimizelyPPID",
                                col2: "Airtable",
                                col3: "Optimizely cookies are used to compare two versions of the same website page, allowing to improve the websites performance.\xa0"
                            },
                            {
                                col1: "__cfruid",
                                col2: "Airtable",
                                col3: "Cookie associated with sites using CloudFlare, used to identify trusted web traffic."
                            },
                            {
                                col1: "__zlcmid",
                                col2: "Airtable",
                                col3: "Store a unique user ID"
                            },
                            {
                                col1: "_help_center_session",
                                col2: "Airtable",
                                col3: "This cookie aids in session for the Zendesk guide."
                            },
                            {
                                col1: "_zendesk_authenticated",
                                col2: "Airtable",
                                col3: "This cookie is used to store a binary variable determining whether a user has been authenticated."
                            },
                            {
                                col1: "_zendesk_session",
                                col2: "Airtable",
                                col3: "This cookie holds session information for root access applications."
                            },
                            {
                                col1: "_zendesk_shared_session",
                                col2: "Airtable",
                                col3: "This cookie holds session information for sharing across Zendesk applications."
                            },
                            {
                                col1: "ajs%3Acookies",
                                col2: "Airtable",
                                col3: "Track traffic to improve the functionality of our website."
                            },
                            {
                                col1: "ajs%3Atest",
                                col2: "Airtable",
                                col3: "Track traffic to improve the functionality of our website."
                            },
                            {
                                col1: "intercom-id-wb1whb4b",
                                col2: "Airtable",
                                col3: "Allows visitors to see any conversations they've had on Airtable websites."
                            },
                            {
                                col1: "intercom-session-wb1whb4b",
                                col2: "Airtable",
                                col3: "Allows users to access their conversations and have data communicated on logged out pages for 1 week."
                            },
                            {
                                col1: "shared_view_signup_7_day_cooldown",
                                col2: "Airtable",
                                col3: "Track visitor usage."
                            },
                            {
                                col1: "zte2095",
                                col2: "Airtable",
                                col3: "Zendesk cookie used to enhance the performance and functionality of the website"
                            },
                            {
                                col1: "_fbp",
                                col2: "Airtable",
                                col3: "Used by Facebook to deliver a series of advertisement products such as real time bidding from third party advertisers"
                            },
                            {
                                col1: "ajs_group_id",
                                col2: "Airtable",
                                col3: "Track visitor usage and events"
                            },
                            {
                                col1: "ajs_user_id",
                                col2: "Airtable",
                                col3: "Track visitor usage and events"
                            },
                            {
                                col1: "drift_aid",
                                col2: "Airtable",
                                col3: "This is the anonymous identifier token. It is used to tie the visitor on your website with the profile within the Drift system. This allows Drift to remember the information that this site visitor has provided through the chat on subsequent site visits."
                            },
                            {
                                col1: "drift_campaign_refresh",
                                col2: "Airtable",
                                col3: "This is the session identifier token. It is used to tie the visitor on your website with a current website session within the Drift system. This is enables session-specific features, such as popping up a messaging only once during a 30 minute session as to prevent a disruptive experience."
                            },
                            {
                                col1: "driftt_aid",
                                col2: "Airtable",
                                col3: "This is the anonymous identifier token. It is used to tie the visitor on your website with the profile within the Drift system. This allows Drift to remember the information that this site visitor has provided through the chat on subsequent site visits."
                            },
                            {
                                col1: "__cf_bm",
                                col2: "Airtable",
                                col3: "The __cf_bm cookie is a cookie necessary to support Cloudflare Bot Management, currently in private beta. As part of our bot management service, this cookie helps manage incoming traffic that matches criteria associated with bots. "
                            },
                            {
                                col1: "_session_id",
                                col2: "Airtable",
                                col3: "This cookie creates an interim session ID used as an in-session user ID. "
                            },
                            {
                                col1: "BIGipServerab47web-nginx-app_https",
                                col2: "Airtable",
                                col3: "This cookie name is associated with the BIG-IP product suite from company F5. Usually associated with managing sessions on load balanced servers, to ensure user requests are routed consistently to the correct server. The common root is BIGipServer most commonly followed by a domain name, usually the one that it is hosted on, but not always."
                            },
                            {
                                col1: "eupubconsent",
                                col2: "Airtable",
                                col3: "This cookie is used by the IAB Europe Transparency & Consent Framework to store the user's consent to the data collection Purposes. The cookie holds an encrypted consent string that vendors participating in the framework can read and determine the user's consent. "
                            },
                            {
                                col1: "OptanonAlertBoxClosed",
                                col2: "Airtable",
                                col3: "This cookie is set by websites using certain versions of the cookie law compliance solution from OneTrust.  It is set after visitors have seen a cookie information notice and in some cases only when they actively close the notice down.  It enables the website not to show the message more than once to a user.  The cookie has a one year lifespan and contains no personal information."
                            },
                            {
                                col1: "OptanonConsent",
                                col2: "Airtable",
                                col3: "This cookie is set by the cookie compliance solution from OneTrust. It stores information about the categories of cookies the site uses and whether visitors have given or withdrawn consent for the use of each category. This enables site owners to prevent cookies in each category from being set in the users browser, when consent is not given. The cookie has a normal lifespan of one year, so that returning visitors to the site will have their preferences remembered. It contains no information that can identify the site visitor."
                            },
                            {
                                col1: "__gsas",
                                col2: "Google Maps",
                                col3: "Advertising"
                            },
                            {
                                col1: "__gpi",
                                col2: "Google Maps",
                                col3: "Advertising"
                            },
                            {
                                col1: "__gpi_optout",
                                col2: "Google Maps",
                                col3: "Advertising"
                            },
                            {
                                col1: "NID",
                                col2: "Google Maps",
                                col3: "Security, Analytics, Functionality, Advertising"
                            },
                            {
                                col1: "DSID",
                                col2: "Google Maps",
                                col3: "Security, Functionality, Advertising"
                            },
                            {
                                col1: "test_cookie",
                                col2: "Google Maps",
                                col3: "Functionality"
                            },
                            {
                                col1: "id",
                                col2: "Google Maps",
                                col3: "Functionality, Advertising"
                            },
                            {
                                col1: "__gads",
                                col2: "Google Maps",
                                col3: "Advertising"
                            },
                            {
                                col1: "GED_PLAYLIST_ACTIVITY",
                                col2: "Google Maps",
                                col3: "Advertising"
                            },
                            {
                                col1: "ACLK_DATA",
                                col2: "Google Maps",
                                col3: "Advertising"
                            },
                            {
                                col1: "pm_sess",
                                col2: "Google Maps",
                                col3: "Security, Functionality"
                            },
                            {
                                col1: "pm_sess_NNN",
                                col2: "Google Maps",
                                col3: "Security, Functionality"
                            },
                            {
                                col1: "aboutads_sessNNN",
                                col2: "Google Maps",
                                col3: "Security, Functionality"
                            },
                            {
                                col1: "FPAU",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "ANID",
                                col2: "Google Maps",
                                col3: "Advertising"
                            },
                            {
                                col1: "AID",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "IDE",
                                col2: "Google Maps",
                                col3: "Advertising"
                            },
                            {
                                col1: "TAID",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "FPGCLDC",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "_gcl_dc",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "_gcl_au",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "FLC",
                                col2: "Google Maps",
                                col3: "Advertising"
                            },
                            {
                                col1: "RUL",
                                col2: "Google Maps",
                                col3: "Advertising"
                            },
                            {
                                col1: "FCCDCF",
                                col2: "Google Maps",
                                col3: "Functionality"
                            },
                            {
                                col1: "FCNEC",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "FPGCLAW",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "FPGCLGB",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "_gcl_gb",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "_gac_gb_<wpid>",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "_gcl_aw",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "1P_JAR",
                                col2: "Google Maps",
                                col3: "Advertising"
                            },
                            {
                                col1: "Conversion",
                                col2: "Google Maps",
                                col3: "Advertising"
                            },
                            {
                                col1: "YSC",
                                col2: "Google Maps",
                                col3: "Security"
                            },
                            {
                                col1: "VISITOR_INFO1_LIVE",
                                col2: "Google Maps",
                                col3: "Security, Advertising"
                            },
                            {
                                col1: "VISITOR_INFO1_LIVE__k",
                                col2: "Google Maps",
                                col3: "Security, Advertising"
                            },
                            {
                                col1: "VISITOR_INFO1_LIVE__default",
                                col2: "Google Maps",
                                col3: "Security, Advertising"
                            },
                            {
                                col1: "FPLC",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "_ga",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "_gac_<wpid>",
                                col2: "Google Maps",
                                col3: "Advertising"
                            },
                            {
                                col1: "_gid",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "_gat[_<customname>]",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "__utma",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "__utmb",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "__utmc",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "__utmt",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "__utmz",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "__utmv",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "AMP_TOKEN",
                                col2: "Google Maps",
                                col3: "Functionality"
                            },
                            {
                                col1: "FPID",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "GA_OPT_OUT",
                                col2: "Google Maps",
                                col3: "Functionality"
                            },
                            {
                                col1: "_ga_<wpid>",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "_dc_gtm_<property-id>",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "_gaexp",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "_gaexp_rc",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "_opt_awcid",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "_opt_awmid",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "_opt_awgid",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "_opt_awkid",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "_opt_utmc",
                                col2: "Google Maps",
                                col3: "Analytics"
                            },
                            {
                                col1: "_gcl_gf",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "_gcl_ha",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "PAIDCONTENT",
                                col2: "Google Maps",
                                col3: "Analytics, Advertising"
                            },
                            {
                                col1: "_opt_expid",
                                col2: "Google Maps",
                                col3: "Analytics"
                            }
                        ]
                    },
                    // {
                    //   title: "Advertisement and Targeting cookies",
                    //   description:
                    //     "These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you",
                    //   toggle: {
                    //     value: "targeting",
                    //     enabled: false,
                    //     readonly: false,
                    //   },
                    // },
                    {
                        title: "Weitere Informationen",
                        description: 'Bei Fragen zu unserer Cookie-Richtlinie und Ihren Auswahlm\xf6glichkeiten wenden Sie sich bitte <a class="cc-link" href="imprint">via Email</a>.'
                    }
                ]
            }
        }
    }
});



})();
//# sourceMappingURL=main.js.map
